import { configureStore } from '@reduxjs/toolkit';
import authReducer from './auth/authReducer';
import homeReducer from './home/homeSlice';
import plansReducer from './plans/plansSlice';
import policyReducer from './policy/policySlice';
import menuReducer from './menu/menuSlice';
import appUserReducer from './slices/appUserSlice';
import trainerReducer from './slices/trainerSlice';
import feedbackReducer from './slices/feedbackSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    home: homeReducer,
    plans: plansReducer,
    policy: policyReducer,
    menu: menuReducer,
    appUser: appUserReducer,
    trainers: trainerReducer,
    feedbacks: feedbackReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disabling for broader compatibility with many API responses
    }),
  devTools: import.meta.env.MODE !== 'production',
});

export default store;
